import { render, staticRenderFns } from "./DashboardTopBarNotifications.vue?vue&type=template&id=e5b0c8a4&scoped=true&"
import script from "./DashboardTopBarNotifications.vue?vue&type=script&lang=js&"
export * from "./DashboardTopBarNotifications.vue?vue&type=script&lang=js&"
import style0 from "./DashboardTopBarNotifications.vue?vue&type=style&index=0&id=e5b0c8a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5b0c8a4",
  null
  
)

export default component.exports